import { useEffect, useRef } from 'react'

export const useRefFromState = <T>(item: T) => {
  const ref = useRef(item)
  useEffect(() => {
    ref.current = item
  }, [item])

  return ref
}
